import FeedbackRoundedIcon from '@mui/icons-material/FeedbackRounded'
import React from 'react'
import { defaultPalette } from '../../../theme/idsTheme'
import { hexToRgba } from '../../../utils/commonUtils'
import FlexBox from '../flexBox/FlexBox'
import { CalloutProps } from './_props'
import sxs from './_styles'

const Callout: React.FC<CalloutProps> = ({
    children,
    icon,
    color,
    backgroundColor = undefined,
    iconAlignment = 'center',
    flex = 1,
    border = true,
}) => {
    const computedColor = color ?? defaultPalette.lightGrey.mediumDark
    return (
        <FlexBox
            alignItems="stretch"
            gap="1rem"
            flex={flex}
            sx={{
                ...sxs.callout,
                background: backgroundColor ?? hexToRgba(computedColor, 0.04),
                border: border ? `2px solid ${computedColor}` : 'none',
                borderRadius: '0.625rem',
            }}
        >
            <FlexBox
                justifyContent={iconAlignment}
                flexDirection="column"
                alignItems="center"
                sx={{
                    ...sxs.calloutIconContainer,
                    '& svg': {
                        fill: computedColor,
                    },
                }}
            >
                {icon ?? <FeedbackRoundedIcon />}
            </FlexBox>
            <FlexBox
                justifyContent="center"
                flexDirection="column"
                alignItems="center"
                sx={sxs.calloutContentContainer}
            >
                {children}
            </FlexBox>
        </FlexBox>
    )
}

export default Callout
